import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

import '../../styles/graphics.scss';

type DataPoint = {
    x: string; // Version
    y: number[]; // Sentiment counts [positive, negative, neutral]
};

type SentimentEvolutionProps = {
    data: DataPoint[];
};

function SentimentEvolution({ data }: SentimentEvolutionProps) {

    const options: ApexOptions = {
        chart: {
            type: 'bar',
            stacked: true,
            stackType: '100%',
            toolbar: { show: false },
            animations: { enabled: true, speed: 800 }
        },
        xaxis: { categories: data.map(({ x }) => x), title: { text: "Version" } },
        yaxis: {
            title: { text: "Number of Reviews" },
            min: 0,
            max: Math.max(...data.map(({ y }) => y.reduce((acc, val) => acc + val, 0)))
        },
        fill: {
            opacity: 0.9,
            type: 'solid'
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['#ffffff']
        },
        colors: ["#22C55E", "#EF4444", "#FBBF24"], // Green for positive, red for negative, yellow for neutral
        tooltip: { y: { formatter: (value) => value.toString() } },
        legend: {
            show: true,
            position: 'top',
            fontSize: '12px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 500,
            markers: {
                strokeWidth: 0,
            },
            itemMargin: {
                horizontal: 10,
                vertical: 4
            }
        },
        grid: {
            borderColor: "#E5E7EB",
            strokeDashArray: 3
        },
        plotOptions: {
            bar: {
                columnWidth: '100%',
                borderRadius: 6,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'center'
                }
            }
        },
    };

    const series = [
        {
            name: "Positive",
            data: data.map(({ y }) => y[0]), // Extracting positive sentiment count
        },
        {
            name: "Negative",
            data: data.map(({ y }) => y[1]), // Extracting negative sentiment count
        },
        {
            name: "Neutral",
            data: data.map(({ y }) => y[2]), // Extracting neutral sentiment count
        },
    ];

    return (
        <div className='rating-evolution'>
            <ReactApexChart
                options={options}
                series={series}
                type="bar"
                height={350} />
        </div>
    );

}

export default SentimentEvolution;